import { render, staticRenderFns } from "./help-support-chat-page.html?vue&type=template&id=57fd65dc&scoped=true&external"
import script from "./help-support-chat-page.js?vue&type=script&lang=js&external"
export * from "./help-support-chat-page.js?vue&type=script&lang=js&external"
import style0 from "./help-support-chat-page.scss?vue&type=style&index=0&id=57fd65dc&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fd65dc",
  null
  
)

export default component.exports